<script setup lang="ts">
import { ProductsCategoryProps } from "./ProductsCategory.props"
import { smOptions, mdOptions } from "./ProductsCategory.carouselOptions"
import { sm } from "~/utils/breakpoints"

defineProps<ProductsCategoryProps>()

const carouselOptions = computed(() => (sm.value ? smOptions : mdOptions))
</script>

<template>
  <section
    class="
      carousel-container-overflowed
      padded
      bg-gradient-to-r
      from-green-main
      to-tiffany-30
      py-10
    "
  >
    <p v-if="title" class="elephant-bold mb-8 text-white">
      {{ title }}
    </p>

    <AppCarousel
      class="carousel-overflowed select-none"
      :swiper-props="carouselOptions"
      :items="cards"
      :theme="carouselOptions?.theme"
      :key="sm ? 1 : 0"
    >
      <template #default="{ item }">
        <ProductBlocksBrandsUtilsCard v-bind="item" />
      </template>
    </AppCarousel>
  </section>
</template>
